<template>
	<!-- begin #footer -->
	<div id="footer" class="footer">
		&copy; 2019 QTrust All Rights Reserved
	</div>
	<!-- end #footer -->
</template>

<script>

export default {
  name: 'Footer',
}
</script>
